import { useMemo } from 'react';
import * as v from 'valibot';

import { useFormSchema } from '../hooks/use-form-schema';
import { getFieldSchema, isFieldRequired } from '../utils/valibot';
import type { createAntdValidator } from '../validators';

interface FieldProps<TName extends string> {
  name: TName;
  children:
    | React.ReactNode
    | ((props: {
        name: TName;
        label: string;
        antdRule: ReturnType<typeof createAntdValidator>['rule'];
        isRequired: boolean;
      }) => React.ReactNode);
}

export const FieldSchema = <TName extends string>({ name, children }: FieldProps<TName>) => {
  const { antdRule, valibotSchema } = useFormSchema();
  const fieldSchema = useMemo(() => getFieldSchema(valibotSchema, name), [valibotSchema, name]);
  const isRequired = useMemo(() => isFieldRequired(valibotSchema, name), [valibotSchema, name]);

  if (!fieldSchema) {
    console.info(`[validator]: field ${name} is not present in validation schema`);
    return null;
  }
  const label = (v.getMetadata(fieldSchema)?.label as string) ?? name;

  return typeof children === 'function'
    ? children({
        antdRule,
        isRequired,
        label,
        name,
      })
    : children;
};
